// Per-regel positie in de Ondertitel Studio (Ritmo).
//
// caption.posX/posY (fracties 0..1) overschrijven de stijl-positie voor één regel.
// Anker = handmatig geplaatste positie (gesleept). Doorgezette posities krijgen
// posOvergenomen: true, zodat opnieuw doorzetten ze bijwerkt en 'tot de volgende
// eigen positie' alleen op echte ankers stopt. Bestaande projecten (zonder
// markering) behandelen elke eigen positie als anker — zelfde gedrag als voorheen.

// Een regel heeft een afwijkende positie (eigen óf overgenomen).
export const hasOwnCaptionPos = (c) => !!c && (c.posX != null || c.posY != null);

export const isPosAnchor = (c) => hasOwnCaptionPos(c) && !c.posOvergenomen;

// Neem de positie van src over op c (muteert c) en markeer die als overgenomen.
export const setCapPos = (c, src) => {
  if (src.posX != null) c.posX = src.posX; else delete c.posX;
  if (src.posY != null) c.posY = src.posY; else delete c.posY;
  if (c.posX != null || c.posY != null) c.posOvergenomen = true; else delete c.posOvergenomen;
};

// Welke regels krijgen de positie van regel ci?
// scope: 'next' = volgende regel · 'block' = tot de eerstvolgende regel met een
// handmatige positie (anker) · 'all' = alle andere regels.
export const captionPosTargets = (captions, ci, scope) => {
  if (scope === 'next') return ci + 1 < captions.length ? [ci + 1] : [];
  if (scope === 'all') return captions.map((_, i) => i).filter(i => i !== ci);
  const targets = [];
  for (let i = ci + 1; i < captions.length && !isPosAnchor(captions[i]); i++) targets.push(i);
  return targets;
};
